import { useLocation, useNavigate } from "react-router-dom";

// Hash links that work both on the homepage (smooth scroll) and from other
// pages (navigate home, then Landing's hash effect scrolls to the section).
export const useHashNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  const href = (hash) => (isHome ? hash : `/${hash}`);

  const go = (e, hash) => {
    if (isHome) {
      e.preventDefault();
      if (hash === "#top") window.scrollTo({ top: 0, behavior: "smooth" });
      else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return { href, go, isHome, navigate };
};
